import { FieldError, useFormContext } from 'react-hook-form';

interface Props {
  name: string;
  value?: string | string[];
  placeholder?: string;
  novalidate?: boolean;
  desktopWidth?: string;
  required?: boolean;

  disabled?: boolean;
}

const FormHidden = ({ name, value, required }: Props): JSX.Element => {
  const { formState, register } = useFormContext();

  let error = formState.errors?.[name] as FieldError | undefined;

  return (
    <div>
      <input
        autoComplete="off"
        type="hidden"
        {...register(name, { required })}
        onChange={(e) => {
          error = undefined;
        }}
        value={value}
      />
      <p className="text-red500 text-tiny absolute my-0">
        {error?.type === 'required' && `Fältet är obligatoriskt`}
      </p>
    </div>
  );
};
export default FormHidden;
